// userService.js
import { get, post, patch } from './common';


export const licenses = () => {
    return get('licence/get-licence');
};

